import React, { useEffect, useState } from 'react'
import Pagination from "@mui/material/Pagination"
import { TablePagination } from '@mui/material';
import TextField from "@mui/material/TextField"
import { PaginationType } from './MUITableTypes';
import { MobergFontFamily } from '../MobergFont/MobergFont';
export default function CustomPagination(props) {
	const { paginationModel, setPaginationModel, totalRowCount, handleNavigate, searchParams, mainTable } = props
	const [pageInput, setPageInput] = useState(paginationModel.pageIndex + 1)

	useEffect(() => {
		setPageInput(paginationModel.pageIndex + 1)
	}, [paginationModel])

	const count = Math.ceil(totalRowCount / paginationModel.pageSize)
	const startRow = paginationModel.pageIndex * paginationModel.pageSize + 1
	const endRow =
		(paginationModel.pageIndex + 1) * paginationModel.pageSize > totalRowCount
			? totalRowCount
			: (paginationModel.pageIndex + 1) * paginationModel.pageSize

	const handleChange = (event, value) => {
		setPaginationModel({
			...paginationModel,
			pageIndex: value - 1,
		})
		setPageInput(value)
		if (mainTable) {
			searchParams.set('page', value)
			handleNavigate()
		}
	}

	const handlePageInputChange = (event) => {
		const inputPage = parseInt(event.target.value, 10)
		setPageInput(inputPage)
	}

	const handlePageInputBlur = () => {
		if (isNaN(pageInput) || pageInput < 1 || pageInput > count) {
			setPageInput(paginationModel.pageIndex + 1)
			return
		}

		setPaginationModel({
			...paginationModel,
			pageIndex: pageInput - 1,
		})
		setPageInput(pageInput)
	}

	const handlePageInputKeyPress = (event) => {
		if (event.key === 'Enter') {
			handlePageInputBlur();
		}
	}

	const getPagination = () => {
		if (props.paginationType === PaginationType.COMPACT) {
			// For the MUI TablePagination component, page starts at 0
			return <TablePagination
				component="div"
				rowsPerPageOptions={-1}
				showFirstButton={true}
				showLastButton={true}
				labelDisplayedRows={() => ""}
				count={count * paginationModel.pageSize}
				page={paginationModel.pageIndex} 
				onPageChange={(event, value) => handleChange(event, value + 1)}
				rowsPerPage={paginationModel.pageSize}
			/>
		}

		return (
			// For the MUI Pagination component, page starts at 1
			<Pagination
				color="primary"
				page={paginationModel.pageIndex + 1} 
				count={count}
				onChange={handleChange}
				showFirstButton
				showLastButton
			/>
		)
	}

	return (
		<div style={{ display: "flex", alignItems: "center" }}>
			<div style={{ fontFamily: MobergFontFamily.REGULAR, marginBottom: '2px' }}>
				{endRow === 0 ? 0 : startRow}-{endRow} of {totalRowCount}
			</div>

			{getPagination()}
			
			<TextField
				label="Go to Page"
				variant="outlined"
				type="number"
				value={pageInput}
				onChange={handlePageInputChange}
				onBlur={handlePageInputBlur}
				onKeyPress={handlePageInputKeyPress}
				inputProps={{
					style: { width: "55px", height: '5px', textAlign: 'center' },
				}}
			/>
		</div>
	)
}
